import React, { Component, memo } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import AdUnit from '../AdUnit';
import { liveBlogTracking } from '../live-blog/tracking';

import './index.scss';

class Slideshow extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    preposition: PropTypes.string.isRequired,
    fullscreentext: PropTypes.string.isRequired,
    backtoarticle: PropTypes.string.isRequired,
    slidedata: PropTypes.instanceOf(Array),
  };

  static defaultProps = {
    slidedata: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      expandClass: '',
      showAd: false,
      currentSlide: 0,
      slideShowClass: `slideshow-${Math.floor(Math.random() * 9000000000) + 1000000000}`,
    };
    if (0 < props.slidedata.length) {
      this.slides = props.slidedata
        .filter((item) => 'video' !== item.type);
    } else {
      this.slides = this.getData()
        .filter((item) => 'video' !== item.type);
    }
    this.stopFull = this.stopFull.bind();
    this.afterChangeHandler = this.afterChangeHandler.bind();
  }

  /**
   * Get slideshow data.
   */
  getData() {
    const {
      id,
      isLiveBlog,
      liveBlogSlides,
    } = this.props;

    return isLiveBlog ? liveBlogSlides : JSON.parse(document.getElementById(`gallery-id-${id}`).innerHTML);
  }

  goFull = (galleryId) => {
    this.setState({
      expandClass: 'gallery-expanded',
      showAd: true,
    });
    document.body.classList.toggle('has-expanded', true);

    if (this.props.isLiveBlog) {
      const liveBlogCard = document.querySelector(`.${galleryId}`).closest('.liveblog-card');
      if (liveBlogCard) {
        liveBlogCard.classList.add('liveblog-card__gallery-expanded');
      }
    }

    document.addEventListener('keydown', this.escFunction, false);
  };

  stopFull = (galleryId) => {
    this.setState({
      expandClass: '',
      showAd: false,
    });
    document.body.classList.toggle('has-expanded', false);

    if (this.props.isLiveBlog) {
      const liveBlogCard = document.querySelector(`.${galleryId}`).closest('.liveblog-card');
      if (liveBlogCard) {
        liveBlogCard.classList.remove('liveblog-card__gallery-expanded');
      }
    }

    document.removeEventListener('keydown', this.escFunction, false);
  };

  escFunction = (event) => {
    const { slideShowClass } = this.state;
    if (27 === event.keyCode) {
      this.stopFull(slideShowClass);
    }
  };

  afterChangeHandler = (currentSlide) => {
    this.setState({ currentSlide });
  };

  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      afterChange: this.afterChangeHandler,
    };

    const {
      currentSlide,
      slideShowClass,
    } = this.state;

    const {
      preposition,
      fullscreentext,
      backtoarticle,
      isLiveBlog,
    } = this.props;

    const liveBlogClass = isLiveBlog ? ' liveblog-card__slideshow--container' : '';

    const { expandClass, showAd } = this.state;

    return (
      <div className={`${slideShowClass}${liveBlogClass}`}>
        <div className={`expand ${expandClass}`}>
          <button
            className="backToArticle"
            onClick={() => {
              if (isLiveBlog) {
                liveBlogTracking('back to card', 'gallery card', slideShowClass);
              }
              this.stopFull(slideShowClass);
            }}
            type="button"
          >
            &lt; {backtoarticle}
          </button>
          <Slider {...settings}>
            {this.slides.map((slide, index) => (
              <div className="gallery-slide" data-index={index}>
                <div className="slide-inner">
                  <div className="gallery-image">
                    <div className="gallery-image-container">
                      {'image' === slide.type &&
                      <img src={slide.url} alt={slide.alt ?? slide.caption} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className="counter">
            {currentSlide + 1} {preposition} {this.slides.length}
          </div>
          <button
            className="fullScreen"
            onClick={() => {
              if (isLiveBlog) {
                liveBlogTracking('expand', 'gallery card', slideShowClass);
              }
              this.goFull(slideShowClass);
            }}
            type="button"
          >
            {fullscreentext}
          </button>
          <div className="metaContainer">
            <div className="slideMeta">
              {this.slides[currentSlide].credit &&
                <cite>{this.slides[currentSlide].credit}</cite>
              }
              {this.slides[currentSlide].caption &&
                <p className="caption">
                  {parse(DOMPurify.sanitize(this.slides[currentSlide].caption))}
                </p>
              }
            </div>
            <div className="slide-ad">
              <AdUnit
                name="topbox"
                shouldRender={showAd}
              />
              <AdUnit
                name="mobilemultibox"
                shouldRender={showAd}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default memo(Slideshow);
